import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var ViewportUpdateClassifier = /*#__PURE__*/function () {
  function ViewportUpdateClassifier() {
    _classCallCheck(this, ViewportUpdateClassifier);
    _defineProperty(this, "types", []);
    _defineProperty(this, "filters", []);
    _defineProperty(this, "removedFilters", []);
    _defineProperty(this, "__combinedTypes", []);
    _defineProperty(this, "__combinedFilters", []);
  }
  return _createClass(ViewportUpdateClassifier, [{
    key: "VCCalculationMethod",
    value: function VCCalculationMethod(_) {
      return {
        VC: {},
        VCBox: {}
      };
    }

    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
  }, {
    key: "filterComponentsLog",
    value: function filterComponentsLog(_ref) {
      var componentsLog = _ref.componentsLog;
      return componentsLog;
    }
  }, {
    key: "mergeConfig",
    value: function mergeConfig() {
      var _this = this;
      this.__combinedTypes = [].concat(_toConsumableArray(this.types), _toConsumableArray((this === null || this === void 0 ? void 0 : this.__combinedTypes) || []));
      var previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter(function (filter) {
        return !_this.removedFilters.includes(filter.name);
      });
      this.__combinedFilters = [].concat(_toConsumableArray(this.filters), _toConsumableArray(previousFilters));
    }
  }, {
    key: "classifyUpdate",
    value: function classifyUpdate(_ref2) {
      var element = _ref2.element,
        type = _ref2.type,
        tags = _ref2.tags,
        ignoreReason = _ref2.ignoreReason;
      if (!this.__combinedTypes.includes(type)) {
        return false;
      }
      return this.__combinedFilters.every(function (_ref3) {
        var filter = _ref3.filter,
          name = _ref3.name;
        return filter({
          type: type,
          tags: tags,
          ignoreReason: ignoreReason
        });
      });
    }
  }]);
}();